import { UserFrontAction } from '../actions/userFront';

const initialState = 'Anónimo';

const userFrontReducer = (state = initialState, action: UserFrontAction) => {
	switch (action.type) {
		case 'user-front/select':
			return action.payload;
		default:
			return state;
	}
};

export default userFrontReducer;
